export const FETCH_CATALOG_PRODUCTS = 'FETCH_CATALOG_PRODUCTS'
export const ALL_FETCH_CATALOG_PRODUCTS = 'ALL_FETCH_CATALOG_PRODUCTS'
export const FETCH_CATALOG_PRODUCTS_SUCCESS = 'FETCH_CATALOG_PRODUCTS_SUCCESS'
export const FETCH_CATALOG_PRODUCTS_FAILURE = 'FETCH_CATALOG_PRODUCTS_FAILURE'
export const TOGGLE_CATALOG_PRODUCTS_TAGGED_PRODUCT = 'TOGGLE_CATALOG_PRODUCTS_TAGGED_PRODUCT'
export const SET_CATALOG_PRODUCTS_ITEMS = 'SET_CATALOG_PRODUCTS_ITEMS'
export const TOGGLE_CATALOG_PRODUCTS_PRODUCT_PROPERTY = 'TOGGLE_CATALOG_PRODUCTS_PRODUCT_PROPERTY'
export const TOGGLE_CATALOG_PRODUCTS_PROPERTY = 'TOGGLE_CATALOG_PRODUCTS_PROPERTY'
export const TOGGLE_CATALOG_PRODUCTS_SHOW_NOTES = 'TOGGLE_CATALOG_PRODUCTS_SHOW_NOTES'
export const SET_CATALOG_PRODUCTS_VIEW_TYPE = 'SET_CATALOG_PRODUCTS_VIEW_TYPE'
export const SET_CATALOG_PRODUCTS_SHOW_LOADING = 'SET_CATALOG_PRODUCTS_SHOW_LOADING'
export const SET_CATALOG_PRODUCTS_SELECTED_SORT_BY = 'SET_CATALOG_PRODUCTS_SELECTED_SORT_BY'
export const UPDATE_CATALOG_PRODUCTS_PRODUCT_NOTE = 'UPDATE_CATALOG_PRODUCTS_PRODUCT_NOTE'
export const CLEAR_CATALOG_PRODUCTS = 'CLEAR_CATALOG_PRODUCTS'
export const TOGGLE_SELECTED_PRODUCTS = 'TOGGLE_SELECTED_PRODUCTS'
export const TOGGLE_SELECT_FOR_ALL_PRODUCTS = 'TOGGLE_SELECT_FOR_ALL_PRODUCTS'
export const CLEAR_SELECTED_PRODUCTS = 'CLEAR_SELECTED_PRODUCTS'
export const SET_ACTIVE_COLLECTION = 'SET_ACTIVE_COLLECTION'
export const SET_CLEAR_ALL_FILTERS = 'SET_CLEAR_ALL_FILTERS'
export const FETCH_MY_COLLECTIONS_SUCCESS = 'FETCH_MY_COLLECTIONS_SUCCESS'
export const FETCH_MY_COLLECTIONS = 'FETCH_MY_COLLECTIONS'
export const FETCH_MY_COLLECTIONS_FAILURE = 'FETCH_MY_COLLECTIONS_FAILURE'
export const TOGGLE_SELECTED_MY_COLLECTIONS_ITEM = 'TOGGLE_SELECTED_MY_COLLECTIONS_ITEM'
export const SET_CATALOG_PRODUCTS_LOAD_MORE = 'SET_CATALOG_PRODUCTS_LOAD_MORE'
export const SET_PRODUCTS_CURRENT_PAGE = 'SET_PRODUCTS_CURRENT_PAGE'
export const TOGGLE_ALL_CATALOG_PRODUCTS = 'TOGGLE_ALL_CATALOG_PRODUCTS'
export const SET_ADD_TO_COLLECTION_MODE = 'SET_ADD_TO_COLLECTION_MODE'
export const REMOVE_SELECTED_PRODUCT = 'REMOVE_SELECTED_PRODUCT'
export const SET_CATALOG_PRODUCT_ACTIVE_ORDER = 'SET_CATALOG_PRODUCT_ACTIVE_ORDER'
export const SYNC_ACTIVE_ORDER_FROM_CART = 'SYNC_ACTIVE_ORDER_FROM_CART'
